import { updateMobileSettings } from '../../../actions/siteadmin/updateMobileSettings'
import { showToaster } from '../../../helpers/toastrMessgaes/showToaster';

async function submit(values, dispatch) {

    if (values.isRequestTimerToneEnable == '1' && !values.requestTimeTone) {
        showToaster({ messageId: 'timer', toasterType: 'error' });

        return;
    }
    if(values.duration === '0' && values.job === '0' && values.estimatedPrice === '0' && values.description === '0' && values.photo === '0' && values.location === '0') {
        showToaster({ messageId: 'atLeastOne', toasterType: 'error' });
        return;
    }
    await dispatch(updateMobileSettings(values));
}

export default submit;